import { ApiRequest } from "../../Common";
import { Tag } from "..";
import { endpoints } from "../Constants/endpoints";

// eslint-disable-next-line consistent-return
export const getTags = async () => {
  const response = await ApiRequest.fromPath(endpoints.getAll())
    .withAuthHeader()
    .get();
  if (response.ok) {
    const tagsResponse: { payload: Tag[] } = await response.json();
    return tagsResponse.payload;
  }
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};
